type GetShareUrlReturn = { url: string; type: 'vanity' | 'default' };
export function getShareUrl(starterVanityUrl: string | null, shortUrl: string): GetShareUrlReturn {
	if (starterVanityUrl) return { url: starterVanityUrl, type: 'vanity' };
	return { url: shortUrl, type: 'default' };
}
